export default __webpack_public_path__ + "static/media/Poppins-SemiBoldItalic.4a841403.svg";